import { Api } from "./Api";

const ADMIN_URL=`/user`

export const getUsersList = async (
    page = 1,
    limit = 5,
    sort = '',
    order = '',
  ) => {
    try {
      const response = await Api.get(`${ADMIN_URL}`, {
        params: {
            page,
            limit,
            sort,
            order,
          },
      });
  
      if (response.data && response.data.userData) {
        return {
          users: response.data.userData || [],
          totalUsers: response.data.totalUsers || 0,
          totalPages: response.data.totalPages || 0,
          currentPage: response.data.currentPage || 1,
          success:response.data.success
        };
      } else {
        console.error('Failed to fetch users: No userData found');
        return { users: [], totalPages: 0, currentPage: 1, totalUsers: 0 };
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 404) {
          console.warn('No users found (404). Returning empty user array.');
          return { users: [], totalPages: 0, currentPage: 1, totalUsers: 0 };
        } else {
          console.error('Error fetching users:', error.response.data.message);
          return { error: error.response.data.message, users: [] };
        }
      } else {
        console.error('Error fetching users:', error.message);
        return { error: 'An error occurred while trying to fetch users', users: [] };
      }
    }
  };
  export const addUser = async ( formData: any) => {
    try {
      const response = await Api.post(`${ADMIN_URL}` , 
        formData 
      );
  
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error adding user:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error adding user:', error.message);
        return { error: 'An error occurred while trying to add user' };
      }
    }
  };
  export const getPermission = async (id: any) => {
    try {
      const response = await Api.get(`permission?user_id=${id}`, 
      );
  
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error adding user:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error adding user:', error.message);
        return { error: 'An error occurred while trying to add user' };
      }
    }
  };
  export const updateUser = async (formData: any,id: any) => {
    try {
      const response = await Api.put(`${ADMIN_URL}/${id}`, 
         formData
      );
  
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error getting status change:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error getting status change:', error.message);
        return { error: 'An error occurred while trying to getting status change' };
      }
    }
  };
  export const userStatusChange = async (id: any,is_active: any) => {
    try {
      const response = await Api.put(`${ADMIN_URL}/${id}`, 
        { is_active}
      );
  
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error getting status change:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error getting status change:', error.message);
        return { error: 'An error occurred while trying to getting status change' };
      }
    }
  };